/// <reference path="../common-types.d.ts" />
import axios, { AxiosResponse } from 'axios'

export const getClaimDetails = async (claimId: number, fieldInvestigatorId: number): Promise<AxiosResponse> => {
    const url = `${appSettings.ApiUrl}/api/ClaimFieldInvestigators/claim/${claimId}/field-investigator/${fieldInvestigatorId}`;

    return await axios.get(url, { withCredentials: true });
}